'use es6';

import NewThreadPrompt from '../../thread-create/components/NewThreadPrompt';
import { connect } from 'react-redux';
import { navigateToStagedThread } from '../../navigation/actions/navigateToStagedThread';
import { getColoring } from '../../selectors/widgetDataSelectors/getColoring';
const mapStateToProps = state => {
  const {
    accentColor
  } = getColoring(state);
  return {
    accentColor
  };
};
const mapDispatchToProps = {
  createNewThread: navigateToStagedThread
};
export default connect(mapStateToProps, mapDispatchToProps)(NewThreadPrompt);